import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

const About = resolve => {
	require.ensure(['./views/About.vue'], () =>{
		resolve(require('./views/About.vue'));
	} );
};
const Contact = resolve => {
	require.ensure(['./views/Contact.vue'], () =>{
		resolve(require('./views/Contact.vue'));
	} );
};
const execProtection = resolve => {
  require.ensure(['./views/service/exec-protection.vue'], () => {
    resolve(require('./views/service/exec-protection.vue'));
  } );
};
const secLogistics = resolve => {
	require.ensure(['./views/service/sec-logistics.vue'], () =>{
		resolve(require('./views/service/sec-logistics.vue'));
	} );
};
const intel = resolve => {
	require.ensure(['./views/service/intelligence.vue'], () =>{
		resolve(require('./views/service/intelligence.vue'));
	} );
};
const guard = resolve => {
	require.ensure(['./views/service/guard.vue'], () =>{
		resolve(require('./views/service/guard.vue'));
	} );
};
const consulting = resolve => {
	require.ensure(['./views/service/consulting.vue'], () =>{
		resolve(require('./views/service/consulting.vue'));
	} );
};
const talks = resolve => {
	require.ensure(['./views/service/talks.vue'], () =>{
		resolve(require('./views/service/talks.vue'));
	} );
};
Vue.use(Router)

export default new Router({
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {title: 'Home'}
		},
		{
			path: '/about',
			name: 'about',
			component: About
		},
		{
			path: '/contact',
			name: 'contact',
			component: Contact
		},
		{
			path: '/executive-protection',
			name: 'execProtection',
			component: execProtection
		},
		{
			path: '/security-logistics',
			name: 'secLogistics',
			component: secLogistics
		},
		{
			path: '/investigations',
			name: 'intel',
			component: intel
		},
		{
			path: '/guard-services',
			name: 'guard',
			component: guard
		},
		{
			path: '/consulting',
			name: 'consulting',
			component: consulting
		},
		{
			path: '/security-talks',
			name: 'talks',
			component: talks
		}
		/*
		{
			path: '/logistics-for-goods',
			name: 'goods',
			component: goods
		},
		{
			path: '/fraud-detection',
			name: 'fraud',
			component: fraud
		}
		*/
	]
})
